import React, { createContext, useState, useContext } from 'react';

const JobContext = createContext();

export function JobProvider({ children }) {
  const [selectedJob, setSelectedJob] = useState(null);
  
  return (
    <JobContext.Provider value={{ selectedJob, setSelectedJob }}>
      {children}
    </JobContext.Provider>
  );
}

export function useJobContext() {
  return useContext(JobContext);
} 